import { UpdateLevelDocument, UpdateLevelMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpdateLevel = () => {
  const [mutate] = useMutation(UpdateLevelDocument, {
    extractorFn: (data: UpdateLevelMutation) => data.jobCatalogMutations.updateJobcatalogLevel,
  })

  const updateLevel = (id: string, name: string) => {
    return mutate({ variables: { id, name } })
  }

  return updateLevel
}

export default useUpdateLevel
